export default __webpack_public_path__ + "static/media/image2.798f6513.png";